var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/isarray@2.0.5/~/isarray/index.js
// module id = 746
// module chunks = 0